var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useModalContext } from '../context';
/**
 * # Modal.Action
 *
 * 모달의 버튼 영역입니다. Actions 하위로 배치해주세요.
 *
 * @prop {ActionProps} {@link ActionProps} 기본 버튼 액션
 *
 * @example ```tsx
 * <Modal.Action onClick={() => void 0}>Button</Modal.Action>
 * ```
 */
var Action = function (props) {
    var _a = useModalContext(props), children = _a.children, _b = _a.type, type = _b === void 0 ? 'button' : _b, disabled = _a.disabled, onClick = _a.onClick;
    return (<Button type={type} onClick={onClick} disabled={disabled}>
      {children}
    </Button>);
};
var Button = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1 1 100%;\n  padding: 1rem 0;\n  border: none;\n  outline: none;\n  margin: 0;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  text-decoration: none;\n\n  ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1 1 100%;\n  padding: 1rem 0;\n  border: none;\n  outline: none;\n  margin: 0;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  text-decoration: none;\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    color: ", ";\n    border-right: 1px solid ", ";\n\n    &:hover {\n      color: ", ";\n    }\n\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      cursor: not-allowed;\n    }\n\n    &:last-child {\n      border-right: none;\n    }\n  "], ["\n    background: ", ";\n    color: ", ";\n    border-right: 1px solid ", ";\n\n    &:hover {\n      color: ", ";\n    }\n\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      cursor: not-allowed;\n    }\n\n    &:last-child {\n      border-right: none;\n    }\n  "])), theme.colors.PRIMARY.BACKGROUND, theme.colors.PRIMARY.ACCENT_5, theme.colors.PRIMARY.ACCENT_2, theme.colors.PRIMARY.FOREGROUND, theme.colors.PRIMARY.ACCENT_4, theme.colors.PRIMARY.ACCENT_1);
});
export { Action };
var templateObject_1, templateObject_2;
//# sourceMappingURL=Action.jsx.map